import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid} from '@material-ui/core';
import Stack from '@mui/material/Stack';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import DialogClassTestDetails from '../components/DialogClassTestDetails';
import DialogTestStart from '../components/DialogTestStart';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import ClassTestsListView from "../components/ClassTestsListView";
import '../styles/bizofficer-a.css';
///import 'font-awesome/css/font-awesome.min.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

function dateFormat(datetime){
	if(datetime && datetime!=null){
		let datetimeArr = datetime.split(" ");
		let dtArr = datetimeArr[0].split("-");
		let tmArr = datetimeArr[1].split(":");
		datetime = dtArr[2]+"-"+dtArr[1]+"-"+dtArr[0]+" "+tmArr[0]+":"+tmArr[1];
	}
	return datetime;
}    
  
const columns = [
	{ field: 'id', headerName: '#', width: 40 },
	{ field: 'testTitle', headerName: 'Test Title', minWidth: 250, renderCell: (params) =>  (
		<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
	   ), },
	{ field: 'subject', headerName: 'Subject', width: 170 },
	{ field: 'testDateTime', headerName: 'Date/Time', type: 'date', width: 170, 
		valueGetter: (params) => {
		return dateFormat(params.value);
	  	}},
	{ field: 'questionType', headerName: 'Question Type', width: 170 },
	{ field: 'totalMark', headerName: 'Total Marks', width: 170 },	  
	{ field: 'totalTime', headerName: 'Duration (Minutes)', width: 170 }
  ];
  
  export default function Execute() {
	const classes = useStyles();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));	
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
	const [pageLoader, setPageLoader] = React.useState(true);
	
	const childRef = React.useRef();
	const childRefStartTest = React.useRef();
	const [testDetail, setTestDetail] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [currentRunningTestTitle, setCurrentRunningTestTitle] = React.useState("");
	const [currentRunningTestSession, setCurrentRunningTestSession] = React.useState("");

	const authResult = new URLSearchParams(window.location.search);
	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}

	React.useEffect(() => {		
		if(selectedCourse && mySelectedCourses  && mySelectedCourses[selectedCourse].courseId>0){
			getApiData(mySelectedCourses[selectedCourse].courseId);	
		}
	}, [selectedCourse]);

	async function getApiData(courseId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/classtestlist?courseId='+courseId, axiosHeader)
			   .then(response => {
				setPageLoader(false);
			 	///console.log("Just Checking >> "+response.data);  
				 if(response.data.responseTxt==="success"){
					setRows(response.data.obj);

				}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					Cookies.remove('isloggedin');
					window.location.href='logout';						

				}				 				 				
			})
	}

	function showDetails(obj){
		if(obj && rows[obj.id-1] && rows[obj.id-1].testId>0){
			setTestDetail(rows[obj.id-1]);
			childRef.current.handleClickOpen();	
		}	
	}

	function startMyTest(){
		///alert("aaaa");
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testcurrentrunning?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					///console.log("Just Checking >> "+response.data);
					if(response.data.responseTxt==="success"){
						setCurrentRunningTestTitle(response.data.testName);
						setCurrentRunningTestSession(response.data.testSession);
						childRefStartTest.current.handleClickOpen();

					}else if(response && response.data && response.data.responseTxt==="invalidToken"){
						Cookies.remove('isloggedin');
						window.location.href='logout';						

					}else{
						let testType = testDetail.scheduleId.split("-")[2];	
						window.location.href='testsimulator?classTestId='+testDetail.scheduleId+'&testType='+testType;
					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
		}		
	}
	function deleteCurrentStartNew(){		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testrunningdelete?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					///console.log("Just Checking >> "+response.data);
					if(response && response.data && response.data.responseTxt==="invalidToken"){
						Cookies.remove('isloggedin');
						window.location.href='logout';						
					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})		
			let testType = testDetail.scheduleId.split("-")[2];	
			window.location.href='testsimulator?classTestId='+testDetail.scheduleId+'&testType='+testType;
		}
	}	
	function continueCurrentTest(){	
		let testType = testDetail.scheduleId.split("-")[2];	
		window.location.href='testsimulator?testSession='+currentRunningTestSession+'&testType='+testType;
	}

	return (
		<div> 
				<MetaTags>
            		<title>Class Test</title>
          		</MetaTags>
				
				<Header />	
	   			<LeftDrawer />
      			<main className={classes.content}>
        		<NotificationAlerts />
				
				{pageLoader?<LinearProgress />:null}
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>	
					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >Class Test</h3>
									{window.screen.width>480?<h4 style={{color:'#f50057'}}>Click on any row to start test</h4>:null}
								</Grid>
							</Grid>
					</Box>

				{window.screen.width>480?
					<div className="tblReport" style={{height: '70vh', width: '100%' }}>
						<DataGrid
							rows={(rows || [])}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}	
							onRowClick={itm => showDetails(itm)}	
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No class test available!</span>
								  </Stack>
								)}}		
						/>
					</div>
				:<ClassTestsListView rows={rows} showDetails={showDetails} />
				}	

				</Box>
				</main>
									
				<DialogClassTestDetails toCallStartTest={startMyTest} testDetail={testDetail} ref={childRef} />
				<DialogTestStart toCallDeleteCurrentStartNew={deleteCurrentStartNew} toCallContinueCurrentTest={continueCurrentTest} currentRunningTestTitle={currentRunningTestTitle} ref={childRefStartTest}  />							

		</div>	
	);
  }